"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  sk: {
    shoppingLists: {
      actions: {
        insert: 'Pridať do košíka',
        rename: 'Premenovať'
      },
      shoppingListsDialog: {
        title: 'Moje nákupné zoznamy'
      },
      saveShoppingListDialog: {
        title: 'Uložiť nákupný zoznam pod menom',
        shoppingListName: {
          label: 'Názov zoznamu',
          helperText: 'Pomenujte nákupný zoznam. Pod menom ho neskôr identifikujete. Meno môžete neskôr zmeniť.',
          helperTextPreview: ''
        }
      },
      shoppingListItemCollapsed: {
        quantity: 'ks'
      }
    }
  }
};
var _default = messages;
exports.default = _default;